/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';

/* Ott-common */
import Card2X3Skeleton from '@dtvgo/card-2x3-skeleton';

/* Styles */
import './CatalogVodSkeleton.scss';

function CatalogVodSkeleton({
  className,
  numberOfCards,
  hideMetadata,
  dark,
}) {
  return (
    <div className={`dtv-html5-c-catalog-vod-skeleton ${className}`}>
      {Array.from({ length: numberOfCards }).fill().map((value, index) => (
        <Card2X3Skeleton
          // eslint-disable-next-line react/no-array-index-key -- only presentational
          key={index}
          className="dtv-html5-c-catalog-vod-skeleton__card"
          hideMetadata={hideMetadata}
          dark={dark}
        />
      ))}
    </div>
  );
}

CatalogVodSkeleton.propTypes = {
  className: PropTypes.string,
  numberOfCards: PropTypes.number,
  hideMetadata: PropTypes.bool,
  dark: PropTypes.bool,
};

CatalogVodSkeleton.defaultProps = {
  className: '',
  numberOfCards: 0,
  hideMetadata: false,
  dark: false,
};

export default memo(CatalogVodSkeleton);
